var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleepBed = function SvgSleepBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 15.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M20.6 11.6v3m0-3h-12m12 0v-1m-20 1h8m-8 0v-1m0 1v3m8-3v-1m0 0v-5a1 1 0 0 1 1-1h7a4 4 0 0 1 4 4v2m-12 0h-8m8 0h12M.6.6v10m5-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
export default SvgSleepBed;